<template>
  <b-overlay
    :show="loadtimer"
    opacity="0.50"
    rounded="sm"
  >
    <b-card>
      <b-row v-if="VincActiva == false">
        <!-- Oferta de codigo QR -->
        <div class="col-12 pricing-free-trial mt-0 ml-0 mb-1">
          <b-row>
            <b-col
              lg="2"
              offset-lg="3"
              class="mx-auto"
            >
              <div class="d-flex justify-content-between mt-3">
                <b-img
                  fluid
                  :src="codeQR"
                  class="pricing-trial-img"
                  alt="svg img"
                />
              </div>
            </b-col>
            <b-col
              lg="10"
              offset-lg="3"
              class="mx-auto"
            >
              <div class="pricing-trial-content d-flex justify-content-between">
                <div class="text-center text-md-left mt-3">
                  <h3 class="text-primary">
                    Disfrute de nuestra mejor aplicación movil con tecnologia VHR!
                  </h3>
                  <h5>Conecte con sus servicios de INDETEC 2022.</h5>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-2 mt-lg-3"
                  >
                    Descargue YA!
                  </b-button>
                </div>

                <!-- images -->
                <b-img
                  fluid
                  :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
                  class="pricing-trial-img"
                  alt="svg img"
                />
              <!--/ images -->
              </div>
            </b-col>
          </b-row>
        </div>
      <!--/ CODE QR -->
      </b-row>
      <b-row v-else>
        <h6 class="section-label mx-1 mb-2">
          Servicio de Autenticación en 2 pasos.
        </h6>
        <b-col
          cols="12"
          class="mb-2"
        >
          <b-form-checkbox
            v-model="ServicioActivo"
            switch
            @change="firmar=true"
          >
            <span> ¿Quieres <b>{{ (!ServicioActivo) ? 'activar' : 'desactivar' }}</b> la verificación en dos pasos? </span>
          </b-form-checkbox>
          <!-- <b-button
            block
            type="submit"
            variant="primary"
            @click="firmar=true"
          >
            <feather-icon
              icon="KeyIcon"
              class="mr-50"
            />
            <span class="align-middle">¿Quieres <b>{{ (!ServicioActivo) ? 'activar' : 'desactivar' }}</b> la verificación en dos pasos?</span>
          </b-button> -->
          <hr class="invoice-spacing">
          <h6>Protege tu cuenta con la verificación en dos pasos</h6>
          <b-card-text>
            Impide que los hackers accedan a tu cuenta con una capa adicional de seguridad. Cuando inicias sesión, la verificación en dos pasos ayuda a proteger la privacidad y la seguridad de tu información personal.
          </b-card-text>
          <div class="media-list">
            <b-media vertical-align="top">
              <template #aside>
                <b-img
                  :src="require('@/assets/images/pages/seguridad/Protect_your_account_Light.svg')"
                  blank-color="#ccc"
                  width="64"
                  alt="placeholder"
                />
              </template>
              <h4 class="media-heading">
                Seguridad sin complicaciones
              </h4>
              <b-card-text class="mb-0">
                Además de tu contraseña, la verificación en dos pasos añade un segundo paso rápido para verificar que eres tú.
              </b-card-text>
            </b-media>
            <b-media vertical-align="top">
              <template #aside>
                <b-img
                  :src="require('@/assets/images/pages/seguridad/safer_from_cyberattacks_Light.svg')"
                  blank-color="#ccc"
                  width="64"
                  alt="placeholder"
                />
              </template>
              <h4 class="media-heading">
                Usa la verificación en dos pasos en todas tus cuentas online
              </h4>
              <b-card-text class="mb-0">
                La verificación en dos pasos es una forma contrastada de impedir ciberataques a gran escala. Actívala siempre que se te ofrezca para proteger todas tus cuentas INDETEC.
              </b-card-text>
            </b-media>
          </div>
        </b-col>
      </b-row>
      <!-- modal auth2 -->
      <b-modal
        id="modSign"
        v-model="firmar"
        hide-footer
        @hide="firmar = false; CkActiveService()"
      >
        <check-in
          :accgranted.sync="Signresp.accgranted"
          :resp.sync="Signresp.datos"
          @closeCheckin="SwitchService()"
        />
      </b-modal>

    </b-card>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BCard,
  BCardText,
  BFormCheckbox,
  BImg,
  BOverlay,
  BMedia,
  BModal,
  // BFormGroup,
  // BFormInput,
  // BInputGroupAppend,
} from 'bootstrap-vue'
import {
  ref, onMounted,
} from '@vue/composition-api'
import { formhttp } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { wsCheckawm } from '../useCuenta'
import CheckIn from '../../components/Signin/CheckIn.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BCardText,
    BFormCheckbox,
    BImg,
    BOverlay,
    BMedia,
    BModal,
    CheckIn,
  },
  directives: {
    Ripple,
  },
  setup() {
    const toast = useToast()
    const Signresp = ref({ accgranted: false, datos: {} })
    const firmar = ref(false)
    const VincActiva = ref(false)
    const ServicioActivo = ref(false)
    const loadtimer = ref(false)
    const codeQR = ref(null)
    const dtQR = ref({
      action: 2,
      task: 'wsCuenta',
    })
    const newConfig = ref({
      action: 4,
      task: 'wsCuenta',
      status: null,
    })

    // revisa el estado del servicio
    const CkActiveService = () => {
      loadtimer.value = true
      wsCheckawm(5).then(response => {
        loadtimer.value = false
        ServicioActivo.value = (response.twoFactorAuth === 1)
        toast({
          component: ToastificationContent,
          props: {
            // title: 'Preparando Información',
            text: `Estado actual: ${response.message}`,
            icon: 'BellIcon',
            variant: 'secondary',
          },
        }, { timeout: 20000, position: 'top-center' })
      }, error => {
        loadtimer.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [CkActiveService]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }
    // obtiene codigo QR
    const GetCodeQR = () => {
      loadtimer.value = true
      store.dispatch('cuenta/postDatosFact', dtQR.value).then(response => {
        loadtimer.value = false
        codeQR.value = response.data
        const { icon, label } = formhttp(response.status)
        toast({
          component: ToastificationContent,
          props: {
            // title: 'Solicitud exitosa',
            text: response.message,
            icon,
            variant: label,
          },
        }, { timeout: 20000, position: 'top-center' })
      }, error => {
        loadtimer.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención, [GetCodeQR]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    // cambia el status del servicio.
    const ChangeService = () => {
      loadtimer.value = true
      store.dispatch('cuenta/postDatosFact', newConfig.value).then(response => {
        loadtimer.value = false
        // ServicioActivo.value = newConfig.value.status
        const { icon } = formhttp(response.status)
        toast({
          component: ToastificationContent,
          props: {
            // title: 'Solicitud exitosa',
            text: response.message,
            icon,
            variant: 'primary',
          },
        }, { timeout: 20000, position: 'top-center' })
        // re-call status
        CkActiveService()
      }, error => {
        loadtimer.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención, [ChangeService]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    // revisa el estado de la vinculacion actual.
    const CheckVin = () => {
      loadtimer.value = true
      wsCheckawm(3).then(response => {
        loadtimer.value = false
        const { icon, label } = formhttp(response.status)
        VincActiva.value = response.alreadyExist
        toast({
          component: ToastificationContent,
          props: {
            text: response.message,
            icon,
            variant: label,
          },
        }, { timeout: 20000, position: 'top-center' })
        if (!VincActiva.value) {
          GetCodeQR() // call code QR
        } else {
          CkActiveService()
        }
      }, error => {
        loadtimer.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [wsCheckVinculacion]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }

    const SwitchService = () => {
      firmar.value = false
      if (Signresp.value.accgranted) {
        newConfig.value.status = ServicioActivo.value ? 1 : 0
        ChangeService()
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Credenciales Invalidas',
            text: 'Lo sentimos pero no hubo autenticación ',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      }
    }

    onMounted(() => CheckVin())

    return {
      // flags
      ServicioActivo,
      VincActiva,
      loadtimer,
      firmar,
      Signresp,
      // datos
      codeQR,
      // functions
      SwitchService,
      CkActiveService,
    }
  },
}
</script>
